module.exports = __webpack_public_path__ + "img/service_icon_2.c0007fa5.svg";